import s from './Input.module.scss';
import {TInputProps} from "@/app/[locale]/common/components/Input/types";

export const Input = (
    {
        type,
        value,
        label,
        size,
        errorStyle,
        required,
        version,
        textSize = 'medium',
        placeholder,
        register,
        minLengthSchema,
        maxLengthSchema,
        validationPattern,
        onChange
    }: TInputProps) => {

    const validationRules = {
        required,
        minLength: minLengthSchema,
        maxLength: maxLengthSchema,
        pattern: validationPattern,
    };

    return (
        <input
            type={type}
            value={value}
            className={`${s.input} ${version && s[version]} ${size && s[size]} ${s[`inputTextSize_${textSize}`]} ${errorStyle ? s.alertBorder : ''}`}
            placeholder={placeholder}
            {...register && register(label, validationRules)}
            onChange={onChange}
        />
    );
};